import { IDesignState, StylePreset } from 'shared-types/workbench-types';
import { LAYER_NAMES } from 'src/workbench/helpers/workbench-enums';
import { PlantBase } from 'src/workbench/plugins/irrigation/irrigation-types';

export const sprinklerHandleName = 'handle.sprinkler';
export const sprinklerHandleFromName = 'handle.from';
export const sprinklerHandleToName = 'handle.to';
export const vertexHandleName = 'handle.polyline.vertex';
export const bisectHandleName = 'handle.polyline.bisect';
export const cropBoxHandleName = 'handle.cropBox';
export const scaleHandleName = 'handle.scale';

// If this cannot be reached, pipes will be sized up as much as possible
export const MININUM_RESIDUAL_PRESSURE = 2.5;

export enum PlantType {
  PERENNIAL = 'Perennial (1 gph)',
  EVERGREEN_SHRUB = 'Evergreen Shrub (2 gph)',
  DECIDUOUS_SHRUB = 'Deciduous Shrub (2 gph)',
  EVERGREEN_TREE = 'Evergreen Tree (3 gph)',
  DECIDUOUS_TREE = 'Deciduous Tree (5 gph)',
}
export const plantSVGS = {
  [PlantType.DECIDUOUS_TREE]:
    '<svg xmlns="http://www.w3.org/2000/svg" stroke="black" fill="none" width="100" height="99.2779" viewBox="0 0 100 99.2779"><title>Asset 13</title><g id="Layer_2" data-name="Layer 2"><g id="Elements"><path d="M26.9841,7.7731,23.9225,8.44,22.51,7.5767l-3.2843,2.708v1.4468l-4.99,1.4674v2.0545l-2.788,1.6148-1.0532,6.11L7.337,24.6464,6.31,26.9947,4.1089,28.0214l-.294,7.0448H1.7612L.9507,38.819H5.2155L6.434,43.6933,5.2155,47.6559,2.4941,49.0084.4651,46.9147,0,49.0084l1.2553,2.5472L0,54.509l2.2145,5.9056.8688,1.2515S1.8645,64.56,2.3214,64.7122s1.2669,3.7492,1.2669,3.7492L3.54,71.4137,8.1812,73.29l1.2229,5.2063,1.7517,2.1317h2.3363l1.0144-2.5126,2.7415-1.3711,4.084.9819,2.0846,2.5214.6855,5.1785L21.6853,88.718l2.1122.8973.0464,1.4968s3.3366,2.5127,3.14,2.7678,1.2566-.3732,1.2566-.3732l4.01.4346V95.86h4.0363l1.1422,1.6751h8.3771s1.5344.7484,1.5234.99,1.98.5164,1.98.5164l1.7515-1.8869,5.1026,2.123,4.6981-.2361V97.1549l2.709-.8607,4.4734-.13,1.3705-1.9035h1.5994L75.19,90.68l4.3538-.1511.9138-3.1224,2.3091-1.4761-2.8271-1.61-1.2164-3.14,2.0019-4.1616,3.3879-.96,2.3828,3.7471,2.3389-.6247,1.351-4.3213,5.81-5.5351-.5494-4.279L96.8992,63.32l.3886-3.5574,1.6757-1.6756-.5329-8.5653L100,46.3586l-2.1591-3.727V38.9808l-2-1.6849.0763-4.1125-1.4139-2.7993.5-2.9121-2.8549-4.076-3.1008,2.2772-3.376.3535L83.6694,23.71l1.4133-3.9254,2.5513-1.06L84.9652,14.25l-7.0659-2.3549L75.3551,7.5767l-2.52-.3536L69.7339,4.24,62.04,3.18,58.8292,0H52.3833l.43,6.148L48.4187,8.99l-7.7146-.9381L38.3432,1.1978l-2.801,1.3546H30.1251Z"/></g></g></svg>',
  [PlantType.EVERGREEN_TREE]:
    '<svg xmlns="http://www.w3.org/2000/svg" stroke="black" width="100" height="95.4624" viewBox="0 0 100 95.4624" fill="none"><title>Asset 10</title><g id="Layer_2" data-name="Layer 2"><g id="Elements"><path d="M10.0813,17.565C21.4785,38.66,0,46.8313,0,46.8313,22.0285,57.34,9.0724,76.417,9.0724,76.417,32.9285,72.2377,33.8261,94.84,33.8261,94.84c16.6908-17.4046,30.9371.6227,30.9371.6227,3.3429-24.0633,25.5716-17.8649,25.5716-17.8649C79.3807,55.9815,100,48.3105,100,48.3105c-21.3488-9.2684-9.2121-29.5464-9.2121-29.5464C67.1784,23.7085,65.9737.1218,65.9737.1218,58.5663,7.3006,49.0186,13.8766,35.4869,0,35.4869,0,34.3647,22.3392,10.0813,17.565Z"/></g></g></svg>',
  [PlantType.DECIDUOUS_SHRUB]:
    '<svg xmlns="http://www.w3.org/2000/svg" stroke="black" fill="none" width="100" height="99.2779" viewBox="0 0 100 99.2779"><title>Asset 13</title><g id="Layer_2" data-name="Layer 2"><g id="Elements"><path d="M26.9841,7.7731,23.9225,8.44,22.51,7.5767l-3.2843,2.708v1.4468l-4.99,1.4674v2.0545l-2.788,1.6148-1.0532,6.11L7.337,24.6464,6.31,26.9947,4.1089,28.0214l-.294,7.0448H1.7612L.9507,38.819H5.2155L6.434,43.6933,5.2155,47.6559,2.4941,49.0084.4651,46.9147,0,49.0084l1.2553,2.5472L0,54.509l2.2145,5.9056.8688,1.2515S1.8645,64.56,2.3214,64.7122s1.2669,3.7492,1.2669,3.7492L3.54,71.4137,8.1812,73.29l1.2229,5.2063,1.7517,2.1317h2.3363l1.0144-2.5126,2.7415-1.3711,4.084.9819,2.0846,2.5214.6855,5.1785L21.6853,88.718l2.1122.8973.0464,1.4968s3.3366,2.5127,3.14,2.7678,1.2566-.3732,1.2566-.3732l4.01.4346V95.86h4.0363l1.1422,1.6751h8.3771s1.5344.7484,1.5234.99,1.98.5164,1.98.5164l1.7515-1.8869,5.1026,2.123,4.6981-.2361V97.1549l2.709-.8607,4.4734-.13,1.3705-1.9035h1.5994L75.19,90.68l4.3538-.1511.9138-3.1224,2.3091-1.4761-2.8271-1.61-1.2164-3.14,2.0019-4.1616,3.3879-.96,2.3828,3.7471,2.3389-.6247,1.351-4.3213,5.81-5.5351-.5494-4.279L96.8992,63.32l.3886-3.5574,1.6757-1.6756-.5329-8.5653L100,46.3586l-2.1591-3.727V38.9808l-2-1.6849.0763-4.1125-1.4139-2.7993.5-2.9121-2.8549-4.076-3.1008,2.2772-3.376.3535L83.6694,23.71l1.4133-3.9254,2.5513-1.06L84.9652,14.25l-7.0659-2.3549L75.3551,7.5767l-2.52-.3536L69.7339,4.24,62.04,3.18,58.8292,0H52.3833l.43,6.148L48.4187,8.99l-7.7146-.9381L38.3432,1.1978l-2.801,1.3546H30.1251Z"/></g></g></svg>',
  [PlantType.EVERGREEN_SHRUB]:
    '<svg xmlns="http://www.w3.org/2000/svg" stroke="black" width="100" height="95.4624" viewBox="0 0 100 95.4624" fill="none"><title>Asset 10</title><g id="Layer_2" data-name="Layer 2"><g id="Elements"><path d="M10.0813,17.565C21.4785,38.66,0,46.8313,0,46.8313,22.0285,57.34,9.0724,76.417,9.0724,76.417,32.9285,72.2377,33.8261,94.84,33.8261,94.84c16.6908-17.4046,30.9371.6227,30.9371.6227,3.3429-24.0633,25.5716-17.8649,25.5716-17.8649C79.3807,55.9815,100,48.3105,100,48.3105c-21.3488-9.2684-9.2121-29.5464-9.2121-29.5464C67.1784,23.7085,65.9737.1218,65.9737.1218,58.5663,7.3006,49.0186,13.8766,35.4869,0,35.4869,0,34.3647,22.3392,10.0813,17.565Z"/></g></g></svg>',
  [PlantType.PERENNIAL]:
    '<svg xmlns="http://www.w3.org/2000/svg" stroke="black" fill="none" width="100" height="100.003" viewBox="0 0 100 100.003"><title>Asset 14</title><g id="Layer_2" data-name="Layer 2"><g id="Elements"><path d="M100,50.003A50,50,0,1,1,50,0,49.9939,49.9939,0,0,1,100,50.003Z"/></g></g></svg>',
};

export const plantOptions: PlantBase[] = [
  {
    name: PlantType.DECIDUOUS_TREE,
    iconSVG: plantSVGS[PlantType.DECIDUOUS_TREE],
    gpm: 0.083333,
    gph: 5,
    defaultWidth: 15,
  },
  {
    name: PlantType.EVERGREEN_TREE,
    iconSVG: plantSVGS[PlantType.EVERGREEN_TREE],
    gpm: 0.05,
    gph: 3,
    defaultWidth: 15,
  },
  {
    name: PlantType.DECIDUOUS_SHRUB,
    iconSVG: plantSVGS[PlantType.DECIDUOUS_SHRUB],
    gpm: 0.033333,
    gph: 2,
    defaultWidth: 3,
  },
  {
    name: PlantType.EVERGREEN_SHRUB,
    iconSVG: plantSVGS[PlantType.EVERGREEN_SHRUB],
    gpm: 0.033333,
    gph: 2,
    defaultWidth: 3,
  },
  {
    name: PlantType.PERENNIAL,
    iconSVG: plantSVGS[PlantType.PERENNIAL],
    gpm: 0.01666666667,
    gph: 1,
    defaultWidth: 2.5,
  },
];
export const sleeveDiameters = [2, 4, 6, 8, 10, 12, 16];

export const itemSizes = {
  valveDiameter: 10,
  valveTextFont: 8,
  genericOutline: 1,
  dripDot: 0.9,
  font: 11,
  treeText: 7,
  treeDot: 2,
  legendFont: 10,
  headSize: 7,
  headClue: 9,
  zoneDot: 8,
  edgeFont: 7,
  pipeSize: 2,
  sleeveDiameter: 1,
  quickCouplerSize: 6,
  smallArcStroke: {
    color: '#333333',
    width: 1,
  },
  mainDashArray: (scale: number) => [6 / scale, 6 / scale],
  dripDashArray: (scale: number) => [
    2 / scale,
    4 / scale,
    8 / scale,
    4 / scale,
  ],
  errorDashArray: (scale: number) => [8 / scale, 1 / scale],
  virtualDashArray: (scale: number) => [4 / scale, 4 / scale],
  sleeveDashArray: (scale: number) => [4 / scale, 4 / scale],
  verticalDashArray: (scale: number) => [1 / scale, 3 / scale],
};

export const meterSizes = [
  {
    size: 0.625,
    display: '5/8"',
    safeFlow: 15,
    losses: [
      { flow: 1, loss: 0.2 },
      { flow: 2, loss: 0.3 },
      { flow: 3, loss: 0.4 },
      { flow: 4, loss: 0.6 },
      { flow: 5, loss: 0.9 },
      { flow: 6, loss: 1.3 },
      { flow: 7, loss: 1.8 },
      { flow: 8, loss: 2.3 },
      { flow: 9, loss: 3 },
      { flow: 10, loss: 3.7 },
      { flow: 11, loss: 4.4 },
      { flow: 12, loss: 5.1 },
      { flow: 13, loss: 6.1 },
      { flow: 14, loss: 7.2 },
      { flow: 15, loss: 8.3 },
      { flow: 16, loss: 9.4 },
      { flow: 17, loss: 10.7 },
      { flow: 18, loss: 12 },
      { flow: 19, loss: 13.4 },
      { flow: 20, loss: 15 },
    ],
  },
  {
    size: 0.75,
    display: '3/4"',
    safeFlow: 22,
    losses: [
      { flow: 1, loss: 0.1 },
      { flow: 2, loss: 0.2 },
      { flow: 3, loss: 0.3 },
      { flow: 4, loss: 0.5 },
      { flow: 5, loss: 0.6 },
      { flow: 6, loss: 0.7 },
      { flow: 7, loss: 0.8 },
      { flow: 8, loss: 1 },
      { flow: 9, loss: 1.3 },
      { flow: 10, loss: 1.6 },
      { flow: 11, loss: 1.9 },
      { flow: 12, loss: 2.2 },
      { flow: 13, loss: 2.6 },
      { flow: 14, loss: 3.1 },
      { flow: 15, loss: 3.6 },
      { flow: 16, loss: 4.1 },
      { flow: 17, loss: 4.6 },
      { flow: 18, loss: 5.2 },
      { flow: 19, loss: 5.8 },
      { flow: 20, loss: 6.5 },
      { flow: 22, loss: 7.9 },
      { flow: 24, loss: 9.5 },
      { flow: 26, loss: 11.2 },
      { flow: 28, loss: 13 },
      { flow: 30, loss: 15 },
    ],
  },
  {
    size: 1,
    display: '1"',
    safeFlow: 36,
    losses: [
      { flow: 4, loss: 0.1 },
      { flow: 5, loss: 0.2 },
      { flow: 6, loss: 0.3 },
      { flow: 7, loss: 0.4 },
      { flow: 8, loss: 0.5 },
      { flow: 9, loss: 0.6 },
      { flow: 10, loss: 0.7 },
      { flow: 11, loss: 0.8 },
      { flow: 12, loss: 0.9 },
      { flow: 13, loss: 1 },
      { flow: 14, loss: 1.1 },
      { flow: 15, loss: 1.2 },
      { flow: 16, loss: 1.4 },
      { flow: 17, loss: 1.6 },
      { flow: 18, loss: 1.8 },
      { flow: 19, loss: 2 },
      { flow: 20, loss: 2.2 },
      { flow: 22, loss: 2.8 },
      { flow: 24, loss: 3.4 },
      { flow: 26, loss: 4 },
      { flow: 28, loss: 4.6 },
      { flow: 30, loss: 5.3 },
      { flow: 32, loss: 6 },
      { flow: 34, loss: 6.9 },
      { flow: 36, loss: 7.8 },
      { flow: 38, loss: 8.7 },
      { flow: 40, loss: 9.6 },
      { flow: 42, loss: 10.6 },
      { flow: 44, loss: 11.7 },
      { flow: 46, loss: 12.8 },
      { flow: 48, loss: 13.9 },
      { flow: 50, loss: 15 },
    ],
  },
  {
    size: 1.5,
    display: '1 1/2"',
    safeFlow: 75,
    losses: [
      { flow: 16, loss: 0.4 },
      { flow: 17, loss: 0.5 },
      { flow: 18, loss: 0.6 },
      { flow: 19, loss: 0.7 },
      { flow: 20, loss: 0.8 },
      { flow: 22, loss: 1 },
      { flow: 24, loss: 1.2 },
      { flow: 26, loss: 1.4 },
      { flow: 28, loss: 1.6 },
      { flow: 30, loss: 1.8 },
      { flow: 32, loss: 2.1 },
      { flow: 34, loss: 2.4 },
      { flow: 36, loss: 2.7 },
      { flow: 38, loss: 3 },
      { flow: 40, loss: 3.3 },
      { flow: 42, loss: 3.6 },
      { flow: 44, loss: 3.9 },
      { flow: 46, loss: 4.2 },
      { flow: 48, loss: 4.5 },
      { flow: 50, loss: 4.9 },
      { flow: 52, loss: 5.3 },
      { flow: 54, loss: 5.7 },
      { flow: 56, loss: 6.2 },
      { flow: 58, loss: 6.7 },
      { flow: 60, loss: 7.2 },
      { flow: 65, loss: 8.3 },
      { flow: 70, loss: 9.8 },
      { flow: 75, loss: 11.2 },
      { flow: 80, loss: 12.8 },
      { flow: 90, loss: 16.1 },
      { flow: 100, loss: 20 },
    ],
  },
  {
    size: 2,
    display: '2"',
    safeFlow: 120,
    losses: [
      { flow: 32, loss: 0.8 },
      { flow: 34, loss: 0.9 },
      { flow: 36, loss: 1 },
      { flow: 38, loss: 1.2 },
      { flow: 40, loss: 1.3 },
      { flow: 42, loss: 1.4 },
      { flow: 44, loss: 1.5 },
      { flow: 46, loss: 1.6 },
      { flow: 48, loss: 1.7 },
      { flow: 50, loss: 1.9 },
      { flow: 52, loss: 2.1 },
      { flow: 54, loss: 2.2 },
      { flow: 56, loss: 2.3 },
      { flow: 58, loss: 2.5 },
      { flow: 60, loss: 2.7 },
      { flow: 65, loss: 3.2 },
      { flow: 70, loss: 3.7 },
      { flow: 75, loss: 4.3 },
      { flow: 80, loss: 4.9 },
      { flow: 90, loss: 6.2 },
      { flow: 100, loss: 7.8 },
      { flow: 110, loss: 9.5 },
      { flow: 120, loss: 11.3 },
      { flow: 130, loss: 13 },
      { flow: 140, loss: 15.1 },
      { flow: 150, loss: 17.3 },
      { flow: 160, loss: 20 },
    ],
  },
  {
    size: 3,
    display: '3"',
    safeFlow: 220,
    losses: [
      { flow: 60, loss: 1.0 },
      { flow: 65, loss: 1.1 },
      { flow: 70, loss: 1.3 },
      { flow: 75, loss: 1.5 },
      { flow: 80, loss: 1.6 },
      { flow: 90, loss: 2 },
      { flow: 100, loss: 2.5 },
      { flow: 110, loss: 2.9 },
      { flow: 120, loss: 3.4 },
      { flow: 130, loss: 3.9 },
      { flow: 140, loss: 4.5 },
      { flow: 150, loss: 5.1 },
      { flow: 160, loss: 5.8 },
      { flow: 170, loss: 6.5 },
      { flow: 180, loss: 7.2 },
      { flow: 190, loss: 8 },
      { flow: 200, loss: 9 },
      { flow: 220, loss: 11 },
      { flow: 240, loss: 13 },
      { flow: 260, loss: 15 },
      { flow: 280, loss: 17.3 },
      { flow: 300, loss: 20 },
    ],
  },
  {
    size: 4,
    display: '4"',
    safeFlow: 350,
    losses: [
      { flow: 80, loss: 0.7 },
      { flow: 90, loss: 0.8 },
      { flow: 100, loss: 0.9 },
      { flow: 110, loss: 1 },
      { flow: 120, loss: 1.2 },
      { flow: 130, loss: 1.4 },
      { flow: 140, loss: 1.6 },
      { flow: 150, loss: 1.8 },
      { flow: 160, loss: 2.1 },
      { flow: 170, loss: 2.4 },
      { flow: 180, loss: 2.7 },
      { flow: 190, loss: 3 },
      { flow: 200, loss: 3.2 },
      { flow: 220, loss: 3.9 },
      { flow: 240, loss: 4.7 },
      { flow: 260, loss: 5.5 },
      { flow: 280, loss: 6.3 },
      { flow: 300, loss: 7.2 },
      { flow: 350, loss: 10 },
      { flow: 400, loss: 13 },
      { flow: 450, loss: 16.2 },
      { flow: 500, loss: 20 },
    ],
  },
];

export const greens = [
  '#78AB46',
  '#4A7023',
  '#629632',
  '#458B00',
  '#7F9A65',
  '#9CBA7F',
  '#659D32',
  '#7F8778',
  '#586949',
  '#608341',
  '#BCED91',
  '#488214',
  '#6A8455',
  '#577A3A',
  '#397D02',
  '#748269',
  '#567E3A',
  '#9DB68C',
  '#C0D9AF',
  '#A6D785',
  '#61B329',
  '#77896C',
  '#687E5A',
  '#3F602B',
  '#3F6826',
  '#8AA37B',
  '#8FA880',
  '#646F5E',
  '#476A34',
  '#435D36',
  '#93DB70',
  '#3B5E2B',
  '#84BE6A',
  '#3A6629',
  '#308014',
  '#9CA998',
  '#55AE3A',
  '#7BBF6A',
  '#C5E3BF',
  '#395D33',
  '#596C56',
  '#A9C9A4',
  '#86C67C',
  '#7BCC70',
  '#8CDD81',
  '#699864',
  '#3D8B37',
  '#5F755E',
  '#B7C8B6',
  '#63AB62',
  '#838B83',
  '#698B69',
  '#2F4F2F',
  '#426F42',
  '#548B54',
  '#8FBC8F',
  '#9BCD9B',
  '#71C671',
  '#7CCD7C',
  '#215E21',
  '#228B22',
  '#B4EEB4',
  '#90EE90',
  '#008B00',
  '#009900',
  '#C1FFC1',
  '#3D9140',
  '#B2D0B4',
  '#4D6B50',
  '#5B9C64',
  '#3F9E4D',
  '#517B58',
  '#BDFCC9',
  '#3D5B43',
  '#31B94D',
  '#96C8A2',
  '#3EA055',
  '#487153',
  '#00611C',
  '#688571',
  '#91B49C',
  '#79A888',
  '#B4D7BF',
  '#337147',
  '#37BC61',
  '#70DB93',
  '#40664D',
  '#92CCA6',
  '#329555',
  '#0E8C3A',
  '#78A489',
  '#3E6B4F',
  '#2C5D3F',
  '#759B84',
  '#2E6444',
  '#2E8B57',
  '#00C957',
  '#34925E',
  '#3CB371',
  '#43CD80',
  '#426352',
  '#607C6E',
  '#006633',
  '#008B45',
  '#00CD66',
];

export const LATEST_VERSION = 1;

export const designDefault: IDesignState = {
  activeBaseRadius: 0,
  activeNozzles: [],
  activeElementType: 'fitting',
  activeTool: 'Select',
  currentZone: '',
  resolution: 5,
  scale: 3.6,
  title: '',
  clientAddress: '',
  contractorName: '',
  contractorAddress: '',
  contractorLogoURL: '',
  zoomLevel: 4,
  center: { x: 50, y: 10 },

  northRotation: 0,
  headSize: 5,
  headZoneDotSize: 8,
  headClueSize: 7,

  lastSave: '',
  pipeAlgoVersion: '1',
  ortho: true,
  pipeSnap: true,
  elementCache: {},
  loading: false,
  version: LATEST_VERSION,
  selectedIDs: [],

  items: [],
  // isMouse: true,
  strokeWidth: 1,
  activeCustomSymbol: 'rock',
  visibleLayers: [
    LAYER_NAMES.DEFAULT,
    LAYER_NAMES.ELEMENTS,
    LAYER_NAMES.SHEETS,
    LAYER_NAMES.EDGES,
    LAYER_NAMES.PLANTS,
    LAYER_NAMES.HEADS,
    LAYER_NAMES.YARDS,
    LAYER_NAMES.BEDS,
    LAYER_NAMES.LEGEND,
    LAYER_NAMES.VALVE_INFO_BOXES,
    LAYER_NAMES.TRACING,
    LAYER_NAMES.BASEMAPS,
    LAYER_NAMES.OVERLAY,
  ],
  lockedLayers: [],
  showArcs: false,
  showGPM: false,
  showPipeLabels: false,
  showSheetPreviews: false,
  showHeadPreviews: false,
  overlayLayerIds: [],
  waterSystems: [],
  waterSystemIndex: 0,
  alerts: [],
  activeBaseKey: '',
  plantMode: 'preview',
  sheetMode: 'draft',
  coverageYards: [],
  disclaimer: '',
  pinnedPopupPosition: null,
};

export const polyHintPurple = '#c321cf';

export const mainPadding = 16;
export const mainPaddingPx = `${mainPadding}px`;
export const otherPadding = 72;
export const otherPaddingPx = `${otherPadding}px`;

// export const mainPadding = '8px';
// export const otherPadding = '56px';

export const irrigationBlue = '#01aef0';
export const paperColors = {
  pipe: '#000000',
};

export const usefulGradients = [
  '#FFFAE8',
  '#FFF6D1',
  '#FFF1B9',
  '#FFECA2',
  '#FFE88B',

  '#FFE374',
  '#FFDF5D',
  '#FFDA46',
  '#339900',
  '#339900',

  '#339900',
  '#339900',
  '#339900',
  '#339900',
  '#4F7DD1',

  '#5D6FB9',
  '#6B61A2',
  '#79538B',
  '#864674',
  '#94385D',

  '#A22A46',
  '#B01C2E',
  '#BE0E17',
];
/*

  '#1ABF00', // 10
  'yellow', // 11
  'orange', // 12
  'red', // 13
  'purple', // 14
  'blue', // 15
  'brown',
  'black',
  */

export const gradientColors = [
  '#FFFFFF',
  '#FFFFFF',
  '#DBE0DA',
  '#DBE0DA',
  '#B7C1B6',
  '#B7C1B6',
  '#94A392',
  '#94A392',
  '#4CCD38',
  '#4CCD38',
  '#1ABF00',
  '#1ABF00',
  '#28B403',
  '#28B403',
  '#36A906',
  '#36A906',
  '#449E09',
  '#449E09',
  '#52930C',
  '#52930C',
  '#61880F',
  '#61880F',
  '#6F7D13',
  '#6F7D13',
  '#7D7216',
  '#7D7216',
  '#8B6719',
  '#8B6719',
  '#995C1C',
  '#995C1C',
  '#A8521F',
  '#A8521F',
  '#B64722',
  '#B64722',
  '#C43C26',
  '#C43C26',
  '#D23129',
  '#D23129',
  '#E0262C',
  '#E0262C',
  '#E8212E',
  '#E8212E',
];

export const gradientColorsOriginal = [
  '#FFFFFF',
  '#EDEFEC',
  '#DBE0DA',
  '#C9D1C8',
  '#B7C1B6',
  '#A6B2A4',
  '#94A392',
  '#829380',
  '#4CCD38',
  '#33C61C',
  '#1ABF00',
  '#21B901',
  '#28B403',
  '#2FAE04',
  '#36A906',
  '#3DA307',
  '#449E09',
  '#4B980B',
  '#52930C',
  '#598D0E',
  '#61880F',
  '#688311',
  '#6F7D13',
  '#767814',
  '#7D7216',
  '#846D17',
  '#8B6719',
  '#92621A',
  '#995C1C',
  '#A0571E',
  '#A8521F',
  '#AF4C21',
  '#B64722',
  '#BD4124',
  '#C43C26',
  '#CB3627',
  '#D23129',
  '#D92B2A',
  '#E0262C',
  '#E8212E',
  '#C5111D',
];

export const zoneColors = [
  '#1CE6FF',
  '#FF34FF',
  '#FF4A46',
  '#008941',
  '#006FA6',
  '#7A4900',
  '#0000A6',
  '#B79762',
  '#004D43',
  '#8FB0FF',
  '#997D87',
  '#5A0007',
  '#809693',
  '#1B4400',
  '#4FC601',
  '#3B5DFF',
  '#4A3B53',
  '#FF2F80',
  '#61615A',
  '#BA0900',
  '#6B7900',
  '#00C2A0',
  '#FFAA92',
  '#FF90C9',
  '#B903AA',
  '#D16100',
  '#000035',
  '#7B4F4B',
  '#A1C299',
  '#300018',
  '#0AA6D8',
  '#013349',
  '#00846F',
  '#372101',
  '#FFB500',
  '#A079BF',
  '#CC0744',
  '#C0B9B2',
  '#001E09',
  '#00489C',
  '#6F0062',
  '#0CBD66',
  '#EEC3FF',
  '#456D75',
  '#B77B68',
  '#7A87A1',
  '#788D66',
  '#885578',
  '#FAD09F',
  '#FF8A9A',
  '#D157A0',
  '#BEC459',
  '#456648',
  '#0086ED',
  '#886F4C',
  '#34362D',
  '#B4A8BD',
  '#00A6AA',
  '#452C2C',
  '#c77557',
  '#a14fc4',
  '#936ecf',
  '#38a878',
  '#5238a8',
  '#326c95',
  '#9dcd6a',
  '#c6535b',
  '#a84f38',
  '#75d182',
  '#a538a8',
  '#d9b98c',
  '#c95e6d',
  '#66ccc0',
  '#a3d47d',
  '#94cf6e',
  '#79cd6a',
  '#9fcd6a',
  '#3b64b0',
  '#d98c98',
  '#915e30',
  '#c14452',
  '#a86538',
  '#3bb07f',
  '#d9998c',
  '#37a49f',
  '#40aabf',
  '#d581b3',
  '#37a136',
  '#57c791',
  '#cd6ab3',
  '#4469c1',
  '#c85b7a',
  '#8fd685',
  '#37a4a1',
  '#d279d1',
  '#3db86e',
  '#a9d279',
  '#d0c071',
  '#d9cb8c',
  '#845ec9',
  '#d98cc2',
  '#9d7f34',
  '#ccc966',
  '#7e2f8e',
  '#995533',
  '#707a29',
  '#70349d',
  '#873bb0',
  '#86682d',
  '#7d8ed4',
  '#8bb03b',
  '#69c144',
  '#4086bf',
  '#56a838',
  '#4752c2',
  '#cf7c6e',
  '#642d86',
  '#7d84d4',
  '#8e442f',
  '#8ea838',
  '#93c85b',
  '#a771d0',
  '#6697cc',
  '#d7d288',
  '#c79c57',
  '#c1446b',
  '#c44f57',
  '#799933',
  '#913930',
  '#4fc4b5',
  '#4c7e2a',
  '#2e8a36',
  '#47c2c0',
  '#5bc6c8',
  '#7a3929',
  '#3bb071',
  '#cfd98c',
  '#af53c6',
  '#53c677',
  '#3737a4',
  '#448cc1',
  '#52c144',
  '#86492d',
  '#7e2a7b',
  '#2a7e48',
  '#c37b4b',
  '#8cd9b4',
  '#26735b',
  '#793ebb',
  '#b86ecf',
  '#4b4fc3',
  '#7bd071',
  '#329563',
  '#8a812e',
  '#44c1ae',
  '#695bc8',
  '#2f348e',
  '#37a44d',
  '#bec757',
  '#8b6acd',
  '#4f5fc4',
  '#d07c71',
  '#3ca8b4',
  '#5f9933',
  '#d1d279',
  '#bb4bc3',
  '#bf406c',
  '#ac5639',
  '#79c34b',
  '#339972',
  '#3e7728',
  '#7aac39',
  '#8a2e6e',
  '#5ec980',
  '#62cb89',
  '#713091',
  '#c757b2',
  '#35297a',
  '#2a5f7e',
  '#4756c2',
  '#5036a1',
  '#282f77',
  '#d58184',
  '#7a5229',
  '#a84738',
  '#329546',
  '#2d8633',
  '#7aa437',
  '#81bed5',
  '#66b03b',
  '#37a49a',
  '#6e53c6',
  '#76b83d',
  '#309188',
  '#b466cc',
  '#7da3d4',
  '#b8cb62',
  '#2e8a5a',
  '#3baab0',
  '#44c16d',
  '#c8c65b',
  '#2b827f',
  '#c79c57',
  '#915630',
  '#d071c6',
  '#8c8cd9',
  '#a6cf6e',
  '#36a149',
  '#3779a4',
  '#799933',
  '#b03b9a',
  '#d7bd88',
  '#7997d2',
  '#993b33',
  '#bd71d0',
  '#5789c7',
  '#2f738e',
  '#b888d7',
  '#d5d581',
  '#39862d',
  '#6dcb62',
  '#47c26a',
  '#4b8dc3',
  '#5eb6c9',
  '#b43c40',
  '#7e2a46',
  '#d2798b',
  '#d7d98c',
  '#7d8ed4',
  '#cb62c4',
  '#81cd6a',
  '#6a297a',
  '#bfd98c',
  '#a8383c',
  '#8a2e46',
  '#c571d0',
  '#32954b',
  '#d788d4',
  '#cf6eba',
  '#4b83c3',
  '#29397a',
  '#762b82',
  '#735826',
  '#8ad788',
  '#368a2e',
  '#953256',
  '#aa62cb',
  '#267358',
  '#d1bf75',
  '#66cc90',
  '#c144a1',
  '#4d36a1',
  '#6ecfa1',
  '#62adcb',
  '#3db8b4',
  '#2b6482',
  '#bb3e68',
  '#b83d68',
  '#5c9933',
  '#344d9d',
];
export const presets: StylePreset[] = [
  {
    name: 'Building',
    style: {
      strokeColor: '#000000',
      strokeWidth: 3,
      dashArray: [],
    },
  },
  {
    name: 'Tracing',
    style: {
      strokeColor: '#000000',
      strokeWidth: 1,
      dashArray: [],
    },
  },
  {
    name: 'Easement',
    style: {
      strokeColor: '#000000',
      strokeWidth: 1,
      dashArray: [0.5, 1, 0.5, 1],
    },
  },

  {
    name: 'Property Line',
    style: {
      strokeColor: '#000000',
      strokeWidth: 1,
      dashArray: [2, 1, 0.5, 1],
    },
  },
];
export const resolutionOptions = [
  { value: 1, text: "1' resolution" },
  { value: 1.5, text: "1.5' resolution" },
  { value: 2, text: "2' resolution" },
  { value: 2.5, text: "2.5' resolution" },
  { value: 3, text: "3' resolution" },
  { value: 3.5, text: "3.5' resolution" },
  { value: 4, text: "4' resolution" },
  { value: 4.5, text: "4.5' resolution" },
  { value: 5, text: "5' resolution" },
  { value: 10, text: "10' resolution" },
];

export const fontSizes = [
  8, 10, 12, 14, 16, 18, 20, 22, 24, 26, 28, 36, 48, 72,
];

export const MAX_ITEMS = 50000;
export const MIN_X = -10000;
export const MAX_X = 10000;
export const MIN_Y = -10000;
export const MAX_Y = 10000;
export const ZOOM_INCREMENT = 1;
export const MIN_ZOOM = 0.15;
export const MAX_ZOOM = 80;
export const MAX_YARDS_FOR_ALGORITHMS = 5;
export const MAX_HEADS_FOR_MST = 10;
export const MAX_COVERAGE_DOTS = 50000;
export const MAX_PIPE_DISTANCE_FOR_LABELS = 3;
export const MAX_BASEMAP_UPLOADS = 50;
export const MAX_FILE_SIZE_MB = 50;

export const dripTubingOptions = [
  { label: '1/4"', value: '0.25' },
  { label: '1/2"', value: '0.5' },
  { label: '3/4"', value: '0.75' },
  { label: '1"', value: '1' },
];

export const defaultDisclaimer = `This is a conceptual irrigation design and only shows the design intent. It is not a construction drawing and therefore does not dimension and detail all construction items. The property owner and/or the contractor shall determine all final dimensions and construction details. Contractor and subsequent subcontractor are responsible for all necessary building permits.\n\nThis is not a surveyed plan and only shows the dimensions taken in the field. Property measurements should be confirmed with a licensed land surveyor if necessary.\n\nThis design done per customer's request, and information is supplied to the contractor by the customer.\n\nDue to non-inspection of the site location and construction procedures, contractor is not responsible for damages that can occur to existing plant material during installation. Design and accompanying packet are property of the contractor and cannot be shared without written permission from the contractor.`;

export const HIGH_RES_SCALE_FACTOR = 3;

export const DEFAULT_TRIAL_DAYS = 30;

export const MAX_FILE_SIZE = MAX_FILE_SIZE_MB * 1024 * 1024; // 20MB

export const sourceTypeLabels = {
  poc: 'POC',
  pump: 'Pump',
  meter: 'Meter',
};
